import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "@/components/Layout";
import Index from "./pages/Index";
import About from "./pages/About";
import ServicesIndex from "./pages/ServicesIndex";
import SeoServicePage from "./pages/services/SeoServicePage";
import AssociateDoctors from "./pages/AssociateDoctors";
import SmileGallery from "./pages/SmileGallery";
import Testimonials from "./pages/Testimonials";
import WriteReview from "./pages/WriteReview";
import BlogHub from "./pages/BlogHub";
import BlogPost from "./pages/BlogPost";
import BookAppointment from "./pages/BookAppointment";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminBlog from "./pages/admin/AdminBlog";
import InvisalignMobileLanding from "./pages/landing/InvisalignMobileLanding";
import InvisalignMobileLandingV2 from "./pages/landing/InvisalignMobileLandingV2";
import DentalImplantsAeoGeo from "./pages/landing/DentalImplantsAeoGeo";
import InvisalignPage from "./pages/advanced/InvisalignPage";
import DentalImplantsPage from "./pages/advanced/DentalImplantsPage";
import RootCanalPage from "./pages/advanced/RootCanalPage";
import TeethWhiteningPage from "./pages/advanced/TeethWhiteningPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          {/* Admin Routes — no Layout wrapper */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="blog" element={<AdminBlog />} />
          </Route>

          {/* Public Routes */}
          <Route element={<Layout><Routes><Route path="*" element={null} /></Routes></Layout>} />
          <Route path="/" element={<Layout><Index /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><ServicesIndex /></Layout>} />
          <Route path="/services/:slug" element={<Layout><SeoServicePage /></Layout>} />
          <Route path="/invisalign-kalyan" element={<Layout><InvisalignPage /></Layout>} />
          <Route path="/dental-implants-kalyan" element={<Layout><DentalImplantsPage /></Layout>} />
          <Route path="/root-canal-kalyan" element={<Layout><RootCanalPage /></Layout>} />
          <Route path="/teeth-whitening-kalyan" element={<Layout><TeethWhiteningPage /></Layout>} />
          <Route path="/associate-doctors" element={<Layout><AssociateDoctors /></Layout>} />
          <Route path="/smile-gallery" element={<Layout><SmileGallery /></Layout>} />
          <Route path="/testimonials" element={<Layout><Testimonials /></Layout>} />
          <Route path="/write-review" element={<Layout><WriteReview /></Layout>} />
          <Route path="/blogs" element={<Layout><BlogHub /></Layout>} />
          <Route path="/blogs/category/:category" element={<Layout><BlogHub /></Layout>} />
          <Route path="/blogs/:slug" element={<Layout><BlogPost /></Layout>} />
          {/* Legacy redirects */}
          <Route path="/blog" element={<Layout><BlogHub /></Layout>} />
          <Route path="/blog/:category" element={<Layout><BlogHub /></Layout>} />
          <Route path="/book-appointment" element={<Layout><BookAppointment /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/thank-you" element={<Layout><ThankYou /></Layout>} />
          <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
          <Route path="/terms-conditions" element={<Layout><TermsConditions /></Layout>} />
          <Route path="/lp/invisalign-mobile" element={<Layout><InvisalignMobileLanding /></Layout>} />
          <Route path="/lp/invisalign-mobile-v2" element={<Layout><InvisalignMobileLandingV2 /></Layout>} />
          <Route path="/lp/dental-implants-kalyan-aeo" element={<Layout><DentalImplantsAeoGeo /></Layout>} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
